import { map, flatten, filter, find, includes, uniqBy } from "lodash"
import { v4 as uuid } from "uuid"

// Utils
import { dateDiff } from "Components/MSF/utils"
import { getYYYYMMDDFromDDMMYYYY } from "Utils/dateUtils"

// Models
import {
  statutFacturation,
  listWorkingRange,
  statutInfrapole,
  statutPpiLevel,
  statutDcsPpi,
  statutTiers,
  statutIcVicIcp,
  statutAt,
  statutFo,
  statutCE,
  statutPL,
  stepInfos,
  getTravauxIndex,
} from "Components/MSF/CaseFile/utils/models"


// Constants
const phaseOneFieldsNumber = 14
const phaseTwoFieldsNumber = 6
const phaseThreeFieldsNumber = 9
const phaseFourFieldsNumber = 8

export const getSelectValue = (response, srcData, step) => {
  switch (step) {
    // label des Select Suivi facturation
    case "statut_ce_pl_etude":
    case "statut_ce_pl_travaux":
      return {
        ...srcData,
        response: statutCE?.find(statut => statut?.id === response),
      }
    case "statut_facturation_pl_etude":
    case "statut_facturation_pl_travaux":
      return {
        ...srcData,
        response: statutFacturation?.find(statut => statut?.id === response),
      }
    case "statut_pl_pl_etude":
    case "statut_pl_pl_travaux":
      return {
        ...srcData,
        response: statutPL?.find(statut => statut?.id === response),
      }

    // label des Select Analyse DCS
    case "statut_dcs_ppi":
      return {
        ...srcData,
        response: statutDcsPpi?.find(statut => statut?.id === response),
      }
    case "statut_at":
      return {
        ...srcData,
        response: statutAt?.find(statut => statut?.id === response),
      }
    case "statut_fo_phase_2":
    case "statut_fo":
      return {
        ...srcData,
        response: statutFo?.find(statut => statut?.id === response),
      }

    // label des SelectNSF Digitalisé
    case "statut_level_infra":
      return {
        ...srcData,
        response: statutInfrapole?.find(statut => statut?.id === response),
      }
    case "statut_tiers":
      return {
        ...srcData,
        response: statutTiers?.find(statut => statut?.id === response),
      }
    case "statut_level_ppi":
      return {
        ...srcData,
        response: statutPpiLevel?.find(statut => statut?.id === response),
      }

    // label des SelectTravaux
    case "statut_IC":
    case "statut_VIC":
    case "statut_ICP":
      return {
        ...srcData,
        response: statutIcVicIcp?.find(statut => statut?.id === response),
      }
    default:
      return srcData
  }
}
// Création de la donnée pour le tableau Planning des travaux
export const getWorksPlanningTable = (getInputValue, primaryColor, trad) => {
  // Header du tableau planning
  const headerTableTmp = [
    { label: "", value: "" },
    { label: trad?.ACCOMPANIMENTS, value: "accompagnement" },
    { label: trad?.CATENARY_BREAKS, value: "coupures_catenaires" },
    { label: trad?.ITC, value: "itc" },
    { label: trad?.ADVERTISERS, value: "annonceurs" },
    { label: trad?.LTV, value: "ltv" },
  ]

  const headerTable = map(headerTableTmp, item => {
    return {
      id: uuid(),
      label: item?.label,
      colorCellule: "#fff",
      backgroundCellule: `${primaryColor}B8`,
    }
  })

  const bodyTableTmp = [
    { label: trad?.IC_VISIT, value: "icVisit" },
    { label: trad?.SETTING_TARGET, value: "settingTarget" },
    { label: trad?.FOLLOWED_BY_DRILLING, value: "followedDrilling" },
    { label: trad?.TARGET_DROP, value: "targetDrop" },
  ]
  // Nombre de colonne dans le table
  const nbColumns = headerTable?.length
  const nbRow = bodyTableTmp?.length + 1
  // Creation celulle
  const listCelulle = filter(headerTableTmp, item => item?.value !== "")
  const celulleDefault = map(listCelulle, (item, indexCol) => {
    return {
      id: uuid(),
      idCel: item?.value,
      indexCol: indexCol,
      label: "",
      value: "",
      isClick: true,
    }
  })
  // Création des array pour formé le tableau planning
  const bodyTable = map(bodyTableTmp, (item, indexRow) => {
    const rowPair = indexRow % 2 == 0
    const firstCellule = {
      id: uuid(),
      label: item?.label,
      colorCellule: rowPair ? primaryColor : "#fff",
      backgroundCellule: rowPair ? "#fff" : `${primaryColor}B8`,
    }

    return flatten([
      firstCellule,
      map(celulleDefault, cel => {
        const idCel = `date_${item?.value}_${cel?.idCel}`
        return {
          ...cel,
          id: uuid(),
          idCel: idCel,
          colorCellule: rowPair ? primaryColor : "#fff",
          backgroundCellule: rowPair ? "#fff" : `${primaryColor}B8`,
          value: getInputValue(idCel)?.split("T")?.[0],
        }
      }),
    ])
  })
  // Data du tableau planning travaux
  const data = [headerTable, ...bodyTable]
  // Check si toute les dates du tableau planning sont remplis
  const cellDate = filter(flatten(data), item => item?.isClick)
  const checkCellNoEmpty = filter(cellDate, item => item?.value !== "")
  const checkData = checkCellNoEmpty?.length === cellDate?.length

  return { data, nbColumns, nbRow, checkData }
}
// Création de la donnée pour le tableau Planning des travaux avec une source
export const getWorksPlanningV2Table = (dataTravaux, primaryColor, trad) => {
  // Header du tableau Capacités
  const headerTableTmp = [
    { label: "", value: "nameWork", type: "string" },
    { label: trad?.ACCOMPANIMENTS, value: "accompagnement", type: "date" },
    { label: trad?.CATENARY_BREAKS, value: "coupures_catenaires", type: "date" },
    { label: trad?.ITC, value: "itc", type: "date" },
    { label: trad?.ADVERTISERS, value: "annonceurs", type: "date" },
    { label: trad?.LTV, value: "ltv", type: "date" },
  ]

  const headerTable = map(headerTableTmp, item => {
    return {
      id: uuid(),
      label: item?.label,
      colorCellule: "#fff",
      backgroundCellule: `${primaryColor}B8`,
    }
  })
  // Nombre de colonne dans le table
  const nbColumns = headerTable?.length

  const bodyTable = map(dataTravaux, (item, indexRow) => {
    const workPlanning = {
      accompagnement: item?.workItems?.filter(work => work?.workType === "accompagnement"),
      coupures_catenaires: item?.workItems?.filter(work => work?.workType === "coupures_catenaires"),
      itc: item?.workItems?.filter(work => work?.workType === "itc"),
      annonceurs: item?.workItems?.filter(work => work?.workType === "annonceurs"),
      ltv: item?.workItems?.filter(work => work?.workType === "ltv"),
    }
    const rowPair = indexRow % 2 == 0
    return map(headerTableTmp, cel => {
      const workItem = workPlanning[cel?.value]
      const valueLine =
        cel?.type === "date"
          ? {
            date: workItem?.map(value =>
              getYYYYMMDDFromDDMMYYYY(value.date?.split(" ")?.[0], "-")
            ),
            timeRange: workItem?.map(value => value?.timeRange),
            isNight: workItem?.map(value => value?.isAtNight),
            dayToDay: workItem?.map(value => value?.weekNight),
          }
          : item?.workName
      const labelLine =
        cel?.type === "date"
          ? valueLine?.date?.map((date, index) =>
            valueLine?.isNight[index] === true && date ? `${trad?.MSF_NIGHT_OF} ${valueLine?.dayToDay[index]} ${date} ${valueLine?.timeRange[index]}` : `${date} ${valueLine?.timeRange[index]}`
          )
          : item?.workName
      return {
        id: uuid(),
        colorCellule: primaryColor,
        backgroundCellule: rowPair ? "#fff" : `#F7DAE2`,
        label: labelLine,
        value: valueLine,
        itemRow: item,
      }
    })
  })
  // Data du tableau Capacités
  const data = [headerTable, ...bodyTable]

  return { data, nbColumns }
}
// Création de la donnée pour le tableau Capacités
export const getCapabilitiesTable = (dataCapabilities, primaryColor, isCaseClosed, trad) => {
  // Header du tableau Capacités
  const headerTableTmp = [
    { label: trad?.MSF_LINES, value: "lines", type: "string" },
    { label: trad?.MSF_WAY, value: "way", type: "string" },
    { label: trad?.MSF_WORKING_RANGE_AVAILABLE, value: "working_range", type: "string" },
    { label: trad?.MSF_AVAILABLE_DATE, value: "available_date", type: "date" },
    { label: trad?.MSF_REMARKS, value: "remarks", type: "string" },
  ]

  const headerTable = map(headerTableTmp, item => {
    return {
      id: uuid(),
      label: item?.label,
      colorCellule: primaryColor,
      backgroundCellule: `#F7DAE2`,
    }
  })
  // Nombre de colonne dans le table
  const nbColumns = headerTable?.length

  const bodyTable = dataCapabilities?.map((item, indexRow) => {
    const rowPair = indexRow % 2 == 0
    return headerTableTmp?.map(cel => {
      return {
        id: uuid(),
        colorCellule: primaryColor,
        backgroundCellule: rowPair ? "#fff" : `#F7DAE2`,
        label: item[cel?.value],
        value: item[cel?.value],
        itemRow: item,
      }
    })
  })
  // Data du tableau Capacités
  const data = [headerTable, ...bodyTable]

  return { data, nbColumns }
}
/**
 * Calcule le pourcentage d'achèvement de chaque phase en fonction des données fournies.
 * @param {Array} datas - Le tableau de données à partir duquel calculer l'achèvement.
 * @param {Array} sourceColumn - Les colonnes de la source de données.
 * @param {Boolean} isCount - Indique si les données fournies sont des compteurs ou non.
 * @returns {Object} - Un objet contenant le pourcentage d'achèvement pour chaque phase.
 */
export const handlePhaseCompletion = (datas, isCount = false) => {
  //TODO: need to change this
  if (isCount) {
    const phaseOneCompletion = ((datas?.find(
      data => data?.phase === "etude_impact"
    )?.step || 0) * 100) / phaseOneFieldsNumber
    const phaseTwoCompletion = ((datas?.find(
      data => data?.phase === "analyse_dcs"
    )?.step || 0) * 100) / phaseTwoFieldsNumber
    const phaseThreeCompletion = ((datas?.find(
      data => data?.phase === "nsf_digitalise"
    )?.step || 0) * 100) / phaseThreeFieldsNumber
    const phaseFourCompletion = ((datas?.find(
      data => data?.phase === "travaux"
    )?.step || 0) * 100) / phaseFourFieldsNumber

    return {
      phaseOneCompletion,
      phaseTwoCompletion,
      phaseThreeCompletion,
      phaseFourCompletion,
    }
  } else {

    const phaseOneCompletion =
      (datas?.filter(
        data =>
          data?.phase === "etude_impact"
      )?.length *
        100) / phaseOneFieldsNumber
    const phaseTwoCompletion =
      (datas?.filter(
        data =>
          data?.phase === "analyse_dcs"
      )?.length * 100) / phaseTwoFieldsNumber
    const phaseThreeCompletion =
      (datas?.filter(
        data =>
          data?.phase === "nsf_digitalise"
      )?.length * 100) / phaseThreeFieldsNumber
    const phaseFourCompletion =
      (datas?.filter(
        data =>
          data?.phase === "travaux"
      )?.length * 100) / phaseFourFieldsNumber

    return {
      phaseOneCompletion,
      phaseTwoCompletion,
      phaseThreeCompletion,
      phaseFourCompletion,
    }
  }
}
// Check infos étape
export const checkInfosStep = (data, phaseInfo, listBusinessUsers) => {
  // Récupération infos responsable
  const infosResponsableOne = listBusinessUsers.find(user => user.USER_ID == data.responsable_phase_1);
  const infosResponsableTwo = listBusinessUsers.find(user => user.USER_ID == data.responsable_phase_2);
  const responsableOne = infosResponsableOne
    ? `${infosResponsableOne?.FIRSTNAME?.substring(0, 1)}. ${infosResponsableOne?.LASTNAME}`
    : ""
  const responsableTwo = infosResponsableTwo
    ? `${infosResponsableTwo?.FIRSTNAME?.substring(0, 1)}. ${infosResponsableTwo?.LASTNAME}`
    : ""
  const fullResponsableNameOne = infosResponsableOne
    ? `${infosResponsableOne?.FIRSTNAME} ${infosResponsableOne?.LASTNAME}`
    : ""
  const fullResponsableNameTwo = infosResponsableTwo
    ? `${infosResponsableTwo?.FIRSTNAME} ${infosResponsableTwo?.LASTNAME}`
    : ""

  const actualPhase = phaseInfo?.phase
  const actualStepInfo = stepInfos.find(step => step?.value === phaseInfo?.step)
  const nextStepInfo = stepInfos.find(step => step?.value === phaseInfo?.nextStep)
  const stepInfoIndex = actualStepInfo?.index !== undefined ? actualStepInfo.index : getTravauxIndex(data?.works_decrees, actualStepInfo?.value)
  const advancementStep = checkAdvancementStep(data, actualPhase, stepInfoIndex)

  switch (actualPhase) {
    case "etude_impact":
      return {
        step: 1,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: fullResponsableNameOne,
        fullResponsableNameTwo: fullResponsableNameTwo,
        responsableOne: responsableOne,
        responsableTwo: responsableTwo,
        advancementStep: advancementStep?.slice(0, 1),
      }
    case "analyse_dcs":
      return {
        step: 2,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: fullResponsableNameOne,
        fullResponsableNameTwo: "",
        responsableOne: responsableTwo,
        responsableTwo: "",
        advancementStep: advancementStep?.slice(0, 2),
      }
    case "nsf_digitalise":
      return {
        step: 3,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: "",
        fullResponsableNameTwo: "",
        responsableOne: "",
        responsableTwo: "",
        advancementStep: advancementStep?.slice(0, 3),
      }
    case "travaux":
      return {
        step: 4,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: "",
        fullResponsableNameTwo: "",
        responsableOne: "",
        responsableTwo: "",
        advancementStep: advancementStep,
      }
    case "termine":
    case "cloture":
      return {
        step: 4,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: "",
        fullResponsableNameTwo: "",
        responsableOne: "",
        responsableTwo: "",
        advancementStep: advancementStep,
      }
    case "annule":
      return {
        step: 4,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: "",
        fullResponsableNameTwo: "",
        responsableOne: "",
        responsableTwo: "",
        advancementStep: [["done"], ["done"], ["done"], ["annule"]],
      }
    default:
      return {
        step: 1,
        inProgressNameStep: actualStepInfo?.label,
        afterNameStep: nextStepInfo?.label,
        fullResponsableNameOne: fullResponsableNameOne,
        fullResponsableNameTwo: fullResponsableNameTwo,
        responsableOne: responsableOne,
        responsableTwo: responsableTwo,
        advancementStep: advancementStep?.slice(0, 1),
      }
  }
}

// Check avancement des phases
export const checkAdvancementStep = (data, phase, index) => {
  const travauxLength = data?.works_decrees == 94 ? 8 : 5
  const phases = {
    etude_impact: Array(6).fill("todo"),
    analyse_dcs: Array(3).fill("todo"),
    nsf_digitalise: Array(6).fill("todo"),
    travaux: Array(travauxLength).fill("todo"),
  }

  const currentPhase = phases[phase] || ["done"]

  for (let i = 0; i <= index; i++) {
    currentPhase[i] = i === index ? "inProgress" : "done"
  }

  return [
    phase === "etude_impact" ? currentPhase : ["done"],
    phase === "analyse_dcs" ? currentPhase : ["done"],
    phase === "nsf_digitalise" ? currentPhase : ["done"],
    phase === "travaux" ? currentPhase : ["done"],
  ]
}

export const getStatusStep = (dataStep, checkKeyStep, statusBeforeStep) => {
  if (statusBeforeStep === "done") {
    // Check si les réponses au clé demander sont présente
    const checkResponse = filter(dataStep, resp => includes(checkKeyStep, resp?.step))
    const checkNbResponse = checkKeyStep?.length === checkResponse?.length
    return checkNbResponse ? "done" : "inProgress"
  } else {
    return "todo"
  }
}

export const addDays = (date, days) => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const getTiming = (date, daysToAdd = 35) => {
  if (date) {
    const dateTiming = addDays(date, daysToAdd)
    const dateDay = new Date()
    const timing = dateDiff(dateDay, dateTiming)
    const day = timing?.day
    const nameTiming = day < 0 ? "jours de retard" : "jours restants"
    return {
      timingName: `${Math.abs(day)} ${nameTiming}`,
      nbDay: day,
      timingStatus: day < 0 ? "delay" : "remaining",
    }
  } else {
    return {
      timingName: "",
      nbDay: 0,
      timingStatus: "",
    }
  }
}

export const handleDeadlineContent = (dateDiff, duration) => {

  const absDateDiff = Math.abs(dateDiff)

  switch (Math.sign(dateDiff)) {
    case 1:
      return {
        daysLeft: `${absDateDiff} jour${absDateDiff > 1 ? "s" : ""} restant${absDateDiff > 1 ? "s" : ""}`,
        duration,
        nbDays: dateDiff
      }
    case -1:
      return {
        daysLeft: `${absDateDiff} jour${absDateDiff > 1 && "s"} de retard`,
        duration,
        nbDays: dateDiff
      }
    case 0:
      return {
        daysLeft: "Dernier jour",
        duration,
        nbDays: dateDiff
      }
    default:
      return {
        daysLef: "",
        duration: 0,
        nbDays: 0,
      }
  }
}

export const getSwitchValue = value => {
  if (value === "true") {
    return true
  } else {
    return false
  }
}

export const getDevisFileNanoId = (environment) => {
  switch (environment) {
    case "":
    case "test":
      return "17828a60-62d7-4dbd-995d-4f92900e11d9-Calcul de devis.xlsm"
    case "preprod":
      return "8d497eca-d149-4d24-80bf-793fe8dce165-Calcul de devis.xlsm"
    case "prod":
      return "4a366dc6-83f1-4a91-a598-65116297349f-Calcul de devis.xlsm"
    default:
      break;
  }
}

export const getUserListWithRole = (businessUsers, businessRoles) => {
  return businessUsers.map(user => ({
    value: user.USER_ID,
    label: `${user.FIRSTNAME} ${user.LASTNAME} - ${businessRoles?.find(role => user?.BUSINESS_ROLE === role?.accessId)?.accessName}`,
    name: `${user.FIRSTNAME} ${user.LASTNAME}`,
    email: user.EMAIL,
    role: businessRoles?.find(role => user?.BUSINESS_ROLE === role?.accessId)?.accessId,
  }))
}

export const getHasDocument = (mailType) => {
  const listMailType = [
    "ouverture_pl",
    "ouverture_pl_travaux",
    "facturation",
    "facturation_travaux",
    "signature_contrat_etude",
    "signature_contrat_travaux",
    "nsf",
    "relance_nsf",
    "at_favorable",
    "at_defavorable",
    "nsf_favorable",
    "nsf_defavorable"
  ]

  return listMailType.includes(mailType)
}

export const getDocumentTag = (mailType) => {
  switch (mailType) {
    case "ouverture_pl":
    case "facturation":
    case "signature_contrat_etude":
      return "contrat_etude"
    case "ouverture_pl_travaux":
    case "facturation_travaux":
    case "signature_contrat_travaux":
      return "contrat_travaux"
    case "at_favorable":
    case "at_defavorable":
      return "analyse_technique"
    case "nsf":
    case "relance_nsf":
      return "nsf"
    case "nsf_favorable":
    case "nsf_defavorable":
      return "fo"
    default:
      return ""
  }
}


export const getDestinatairesList = (listUsers, businessRoles, mailType, affaire) => {
  const facturationRoleId = businessRoles?.find(role => role?.tag === "msf_facturation")?.accessId
  const ppiRoleId = businessRoles?.find(role => role?.tag === "msf_ppi")?.accessId

  switch (mailType) {
    case "besoin_msf_oui":
    case "besoin_msf_non":
    case "signature_contrat_etude":
    case "relance_signature_contrat_etude":
    case "signature_contrat_travaux":
    case "relance_signature_contrat_travaux":
    case "at_favorable":
    case "at_defavorable":
    case "relance_nsf":
      return mergeUserListAndContactList(listUsers, affaire)
    case "ouverture_pl":
    case "ouverture_pl_travaux":
    case "facturation":
    case "facturation_travaux":
      return listUsers.filter(user => user.role === facturationRoleId)
    case "demande_msf_ppi":
      return listUsers.filter(user => user.role === ppiRoleId)
    default:
      return listUsers
  }
}

export const getInterlocuteursList = (listUsers, businessRoles, mailType, affaire) => {
  const celluleMsfRoleId = businessRoles?.find(role => role?.tag === "msf_cellule_msf")?.accessId

  switch (mailType) {
    case "signature_contrat_etude":
    case "relance_signature_contrat_etude":
    case "signature_contrat_travaux":
    case "relance_signature_contrat_travaux":
    case "ouverture_pl":
    case "ouverture_pl_travaux":
    case "facturation":
    case "facturation_travaux":
    case "demande_msf_ppi":
      return listUsers.filter(user => user.role === celluleMsfRoleId)
    default:
      return listUsers
  }
}

export const getContactFromAffaire = (affaire) => {
  const moa = {
    value: "moa",
    label: `${affaire?.moa?.moa_name} - MOA`,
    name: affaire?.moa?.moa_name,
    email: affaire?.moa?.moa_email,
    id: "moa",
  }
  const moe = {
    value: "moe",
    label: `${affaire?.moe?.moe_name} - MOE`,
    name: affaire?.moe?.moe_name,
    email: affaire?.moe?.moe_email,
    id: "moe",
  }
  const csps = {
    value: "csps",
    label: `${affaire?.csps?.csps_name} - CSPS`,
    name: affaire?.csps?.csps_name,
    email: affaire?.csps?.csps_email,
    id: "csps",
  }
  const company = {
    value: "company",
    label: `${affaire?.company?.company_contact} - ${affaire?.company?.company_name}`,
    name: affaire?.company?.company_contact,
    email: affaire?.company?.company_email,
    id: "company",
  }
  return [moa, moe, csps, company].filter(contact => contact?.email)
}

export const mergeUserListAndContactList = (listUsers, affaire) => {
  const newListUsers = listUsers.filter(user => affaire?.third_party_users?.includes(user.value))
  const listContact = getContactFromAffaire(affaire)
  const listUsersWithIds =
    newListUsers?.map(user => {
      const contact = listContact.find(contact => contact.email === user.email);
      if (contact) {
        user.id = contact.id;
      }
      return user;
    });

  return uniqBy([...listUsersWithIds, ...listContact], 'email');
}